import React from 'react';
export function ExecutionScopeSection() {
  const scopes = [{
    title: 'Founder leverage',
    detail: 'Time, decision load, delegation, operational offload'
  }, {
    title: 'Execution systems',
    detail: 'Company OS, workflows, documentation, decision frameworks'
  }, {
    title: 'Product & delivery',
    detail: 'Roadmaps, sequencing, prioritization, rituals, research'
  }, {
    title: 'Team dynamics',
    detail: 'Role clarity, conflict resolution'
  }, {
    title: 'Focus & metrics',
    detail: 'Operating goals, critical metrics'
  }, {
    title: 'Critical moments',
    detail: 'Fundraise, accelerators, inflection points'
  }];
  return <section id="scope" className="py-24 md:py-32 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-60">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-61">
        <div className="md:col-span-4" data-id="element-62">
          <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-63">
            Execution Scope
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-black mb-4" data-id="element-64">
            Where I step in
          </h3>
          <p className="text-lg text-gray-600" data-id="element-65">
            Scope is defined up front, based on where operational load is
            blocking progress.
          </p>
        </div>

        <div className="md:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8" data-id="element-66">
          {scopes.map((scope, index) => <div key={index} data-id="element-67">
              <h4 className="text-xl font-medium text-black mb-2" data-id="element-68">
                {scope.title}
              </h4>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-69">
                {scope.detail}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}